import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics } from './analytics';

// Run synchronously before render so window.gtag is wired before any
// child useEffect fires. /www_v1's marketing module installs CTA
// listeners in IndexPageV1.useEffect, which runs before App.useEffect,
// so a lazy init in App was racing the listeners.
initializeAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<App />} />
        {/* Define other routes here */}
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
